import React, { useEffect, useState } from "react";

import FilterListIcon from "@mui/icons-material/FilterList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Typography,
  Box,
  Button,
  Grid,
  Card,
  Badge,
  Tooltip,
  Avatar,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Methods from "../../../utility/Methods.js";

import constants from "../../../common/constants.js";
import { getSession } from "../../../utility/SessionManager.js";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";

import { saveAs } from "file-saver";
import axios from "axios";
import Colors from "../../../utility/Colors.js";
import {
  resetAadharOtp,
  resetEnrolByAadhar,
} from "../../Register/reducer/abhaAadhar/slice.js";

const AbhaProfile = ({}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = Methods.getRole();
  const [userDetails, setUserDetails] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const enrolByAadhar = useSelector((state) => state.abhaAddress.enrolByAadhar);
  const {
    status: enrolByAadharStatus,
    data: enrolByAadharData,
    error: enrolByAadharError,
  } = enrolByAadhar;

  const handleShowSnackbar = (severity, message) => {
    setSnackbarOpen({
      open: true,
      severity: severity,
      message: message,
    });
  };

  useEffect(() => {
    if (enrolByAadharStatus === "succeeded") {
      console.log(
        "response",
        JSON.parse(Methods.decryptData(enrolByAadharData?.data))
      );
      let decData = JSON.parse(Methods.decryptData(enrolByAadharData?.data));
      console.log("enrolByAadhar data", decData.response);
      let finalData = decData.response;
      setUserDetails(finalData);
      // navigate(constants.PATH_DASHBOARD);
    } else if (enrolByAadharStatus === "failed") {
      handleShowSnackbar("error", enrolByAadharError?.error?.errorMessage);
    }
  }, [enrolByAadharStatus]);

  useEffect(() => {
    window.scrollTo(0, 0);
    //!to reset next button redirection functionality
    return () => {
      dispatch(resetEnrolByAadhar());
      dispatch(resetAadharOtp());
    };
  }, []);

  // Convert base64 image if present
  const imgSrc = userDetails?.ABHAProfile?.photo
    ? `data:image/jpeg;base64,${userDetails?.ABHAProfile?.photo}`
    : "";

  const getAuthToken = () => {
    return Methods.decryptData(
      getSession(window, constants.SS_KEY_GROUP_ACCESS_TOKEN)
    );
  };

  const handleFileDownload = () => {
    const authToken = getAuthToken().replace(/^"|"$/g, "");
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/profile/account/abha-card`;

    axios
      .get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "image/png",
        },
      })
      .then((res) => {
        console.log("resss", res);
        console.log("Response size:", res.data.byteLength);
        const blob = new Blob([res.data]);
        saveAs(blob, "ABHA_Card.png");
      })
      .catch((error) => {
        console.error("Download error:", error);
      });
  };

  const handleFilePrint = () => {
    const authToken = getAuthToken().replace(/^"|"$/g, "");
    const fileUrl = `${process.env.REACT_APP_ABHA_BACKEND_URL}/profile/account/abha-card`;

    axios
      .get(fileUrl, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "image/png",
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "image/png" });
        const blobUrl = URL.createObjectURL(blob);

        const printWindow = window.open("", "_blank", "noopener,noreferrer");
        if (printWindow) {
          printWindow.opener = null;
          const doc = printWindow.document;
          const html = doc.documentElement;
          const head = doc.createElement("head");
          const body = doc.createElement("body");

          const title = doc.createElement("title");
          title.textContent = "Print ABHA Card";

          const style = doc.createElement("style");
          style.textContent = `
                body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; }
                img { max-width: 100%; max-height: 100%; }
              `;

          const img = doc.createElement("img");
          img.src = blobUrl;
          img.alt = "ABHA Card";

          head.appendChild(title);
          head.appendChild(style);
          body.appendChild(img);

          // Build the document
          html.replaceChildren(head, body);

          // Print handler
          img.onload = () => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
          };

          doc.close();
        } else {
          console.error("Failed to open print window.");
        }
      })
      .catch((error) => {
        console.error("Print error:", error);
      });
  };

  return (
    <div style={{ width: "100%" }}>
      <Card
        sx={{
          width: "fullWidth",
          marginTop: "10px",
          minHeight: "100vh",
          borderRadius: "10px",
          p: 2,
          boxShadow: `0 2px 5px ${Colors.DARK_GREY}`,
          "&:hover": {
            boxShadow: "#008080 0px 2px 5px",
          },
        }}
      >
        {/* {downloadAwardExcelStatus === "pending" ? <Backdrop /> : null}{" "} */}
        <Grid sx={{ display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "100%", maxWidth: 620, my: 3, px: 2 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: "bold",
                textAlign: "center",
                letterSpacing: "0.5px",
              }}
            >
              Welcome,{" "}
              {`${userDetails?.ABHAProfile?.firstName} ${userDetails?.ABHAProfile?.middleName} ${userDetails?.ABHAProfile?.lastName}`}
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                sx={{ color: "#f5841f", mr: 2 }}
                startIcon={<DownloadIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  handleFileDownload();
                }}
              >
                Download ABHA Card
              </Button>
              <Button
                sx={{ color: "#f5841f" }}
                startIcon={<PrintIcon />}
                onClick={(e) => {
                  e.preventDefault();
                  handleFilePrint();
                }}
              >
                Print ABHA Card
              </Button>
            </Grid>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: 2,
                background: "#fff",
                p: 2,
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  mb: 2,
                  fontSize: "1.18rem",
                  letterSpacing: "0.2px",
                  background: "#0284c9",
                  p: 2,
                  borderRadius: "5px",
                  color: "#fff",
                }}
              >
                Ayushman Bharat Health Account (ABHA)
              </Typography>
              <Grid container alignItems="flex-start">
                {/* Profile Pic */}
                <Grid
                  item
                  size={{ xs: 4 }}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src={imgSrc}
                    alt={userDetails?.ABHAProfile?.firstName}
                    style={{
                      width: 150,
                      height: 180,
                      border: "1.5px solid #e0e0e0",
                      borderRadius: "5px",
                      objectFit: "cover",
                      borderRadius: 3,
                    }}
                  />
                </Grid>
                {/* Info Fields */}
                <Grid item size={{ xs: 8 }}>
                  <Box sx={{ pl: 8 }}>
                    {/* Name */}
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "1.1rem",
                        mb: 0.5,
                        letterSpacing: "0.1px",
                      }}
                    >
                      {`${userDetails?.ABHAProfile?.firstName} ${userDetails?.ABHAProfile?.middleName} ${userDetails?.ABHAProfile?.lastName}`}
                    </Typography>
                    {/* ABHA Number */}
                    {/* ABHA Number */}
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                    >
                      <span style={{ color: "#67676F" }}>
                        <b>ABHA Number:</b>
                      </span>{" "}
                      <span style={{ letterSpacing: "2px" }}>
                        <b>{userDetails?.ABHAProfile?.ABHANumber}</b>
                      </span>
                    </Typography>

                    {/* ABHA Address */}
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                    >
                      <span style={{ color: "#67676F" }}>
                        <b>ABHA Address:</b>
                      </span>{" "}
                      <span>
                        <b>
                          {userDetails?.ABHAProfile?.phrAddress
                            ? userDetails?.ABHAProfile?.phrAddress[0]
                            : "-"}
                        </b>
                      </span>
                    </Typography>

                    {/* Gender, DOB, Mobile */}
                    <Grid
                      container
                      spacing={2}
                      sx={{ mt: 0.5, mb: 0.25, maxWidth: 360 }}
                    >
                      <Grid item xs={4}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "1.05rem",
                            mb: 0.25,
                          }}
                        >
                          <span style={{ color: "#67676F" }}>
                            <b>Gender:</b>
                          </span>{" "}
                          <span>
                            <b>
                              {userDetails?.ABHAProfile?.gender === "M"
                                ? "Male"
                                : userDetails?.ABHAProfile?.gender === "F"
                                ? "Female"
                                : ""}
                            </b>
                          </span>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "1.05rem",
                            mb: 0.25,
                          }}
                        >
                          <span style={{ color: "#67676F" }}>
                            <b>Date of Birth:</b>
                          </span>{" "}
                          <span>
                            <b>{userDetails?.ABHAProfile?.dob}</b>
                          </span>
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "1.05rem",
                            mb: 0.25,
                          }}
                        >
                          <span style={{ color: "#67676F" }}>
                            <b>Mobile:</b>
                          </span>{" "}
                          <span>
                            <b>{userDetails?.ABHAProfile?.mobile}</b>
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>

                    {/* Status */}
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                    >
                      <span style={{ color: "#67676F" }}>
                        <b>Status:</b>
                      </span>{" "}
                      <span>
                        <b>{userDetails?.ABHAProfile?.abhaStatus}</b>
                      </span>
                    </Typography>

                    {/* Verified Status */}
                    <Typography
                      sx={{ fontWeight: 500, fontSize: "1.05rem", mb: 0.25 }}
                    >
                      <span style={{ color: "#67676F" }}>
                        <b>Verified Status:</b>
                      </span>{" "}
                      <span>
                        <b>{userDetails?.ABHAProfile?.verifiedStatus}</b>
                      </span>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Card>
    </div>
  );
};

export default AbhaProfile;
